(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tes-order-benefits"] && !Shopify.designMode) return;
  try {
    function tesOrderBenefitsFallbackCopy(value) {
    const textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand('copy');
    textarea.remove();
    return copied;
  }

  document.addEventListener('click', async (event) => {
    const toggle = event.target.closest('[data-tes-benefits-toggle]');

    if (toggle) {
      const section = toggle.closest('.tes-order-benefits');
      const expanded = section.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', String(expanded));
      return;
    }

    const button = event.target.closest('[data-tes-copy-code]');
    if (!button) return;

    const code = button.dataset.code;
    let copied = false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        copied = await Promise.race([
          navigator.clipboard.writeText(code).then(() => true),
          new Promise((resolve) => window.setTimeout(() => resolve(false), 600))
        ]);
      } catch (error) {
        copied = false;
      }
    }

    if (!copied) {
      copied = tesOrderBenefitsFallbackCopy(code);
    }

    if (!copied) return;

    const value = button.querySelector('[data-tes-code-value]');
    const status = button.closest('.tes-order-benefits').querySelector('[data-tes-copy-status]');
    const originalLabel = button.dataset.originalLabel || value.textContent.trim();
    button.dataset.originalLabel = originalLabel;
    window.clearTimeout(button.tesOrderBenefitsTimer);
    value.textContent = button.dataset.copiedLabel;
    button.classList.add('is-copied');
    button.setAttribute('aria-label', button.dataset.copiedAnnouncement);
    status.textContent = button.dataset.copiedAnnouncement;

    button.tesOrderBenefitsTimer = window.setTimeout(() => {
      value.textContent = originalLabel;
      button.classList.remove('is-copied');
      button.setAttribute('aria-label', button.dataset.copyLabel);
      status.textContent = '';
    }, 1600);
  });
  } catch(e) { console.error(e); }
})();

})();
